var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "search-table" },
        [
          _c("el-date-picker", {
            staticStyle: { width: "115px" },
            attrs: {
              clearable: false,
              type: "month",
              placeholder: "Chọn tháng",
              "value-format": "M-yyyy",
              format: "MM-yyyy",
            },
            on: { change: _vm.handleFilterChange },
            model: {
              value: _vm.filters.monthAndYear,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "monthAndYear", $$v)
              },
              expression: "filters.monthAndYear",
            },
          }),
          _c("el-input", {
            staticStyle: { width: "300px" },
            attrs: { clearable: "", placeholder: "Nhập tên" },
            on: { clear: _vm.handleClearKidName },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleSearchResultByName.apply(null, arguments)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "append",
                fn: function () {
                  return [
                    _c("el-button", {
                      attrs: { icon: "el-icon-search" },
                      on: { click: _vm.handleSearchResultByName },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.filters.kidName,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "kidName", $$v)
              },
              expression: "filters.kidName",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "table-content row-data",
          staticStyle: { "margin-top": "12px" },
        },
        [
          _c(
            "el-tabs",
            {
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleTabChange },
              model: {
                value: _vm.activeTabName,
                callback: function ($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "HĐ lưu nháp", name: "invoice-list" } },
                [
                  _c("InvoiceTabListOther", {
                    attrs: {
                      rows: _vm.pagedRows,
                      loading: _vm.loadingData,
                      "empty-text": _vm.textTable,
                    },
                    on: {
                      action: _vm.handleTabAction,
                      refresh: _vm.fetchInvoiceManagement,
                      "open-preview": _vm.handleOpenPreview,
                      "edit-draft": _vm.handleEditDraft,
                      "selection-change": _vm.handleTableSelectionChange,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "Đã phát hành", name: "issued-list" } },
                [
                  _c("InvoiceTabIssuedOther", {
                    attrs: {
                      rows: _vm.pagedRows,
                      loading: _vm.loadingData,
                      "empty-text": _vm.textTable,
                    },
                    on: {
                      action: _vm.handleTabAction,
                      refresh: _vm.fetchInvoiceManagement,
                      "selection-change": _vm.handleTableSelectionChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "DialogBase",
        {
          attrs: {
            visible: _vm.previewDialogVisible,
            title: "Xem trước hóa đơn nháp",
            width: "90%",
            top: "1vh",
            "use-panel": false,
            "show-cancel": false,
            "confirm-text": "Đóng",
            "confirm-type": "danger",
            "confirm-icon": "",
            "dialog-class": "preview-dialog-no-limit",
            "append-to-body": "",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewDialogVisible = $event
            },
            confirm: _vm.handlePreviewDialogClose,
            "before-close": _vm.handlePreviewDialogBeforeClose,
          },
        },
        [
          _vm.previewPdfUrl
            ? _c("div", { staticClass: "preview-pdf-wrapper" }, [
                _c(
                  "object",
                  {
                    staticClass: "preview-pdf-iframe",
                    style: { width: "100%", height: "calc(100vh - 220px)" },
                    attrs: { data: _vm.previewPdfUrl, type: "application/pdf" },
                  },
                  [
                    _c("iframe", {
                      staticStyle: {
                        width: "100%",
                        height: "100%",
                        border: "none",
                      },
                      attrs: { src: _vm.previewPdfUrl },
                    }),
                  ]
                ),
              ])
            : _c("div", [
                _c("pre", { staticClass: "preview-json" }, [
                  _vm._v("Không có file"),
                ]),
              ]),
        ]
      ),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "15px" } },
        [
          _c(
            "el-col",
            {
              staticStyle: {
                display: "inline-flex",
                "justify-content": "right",
              },
              attrs: { span: 15 },
            },
            [
              _c("el-pagination", {
                staticStyle: {
                  "margin-right": "5.2rem",
                  "margin-left": "auto",
                },
                attrs: {
                  "current-page": _vm.filters.page,
                  "page-sizes": _vm.listSizeLimit,
                  "page-size": _vm.filters.limit,
                  layout: "prev, pager, sizes, next",
                  total: _vm.totalRows,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.filters, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.filters, "page", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticStyle: {
                display: "inline-flex",
                "justify-content": "right",
              },
              attrs: { span: 9 },
            },
            [
              _c(
                "div",
                { staticClass: "batch-action-menu" },
                [
                  _c(
                    "el-dropdown",
                    {
                      attrs: { trigger: "click" },
                      on: { command: _vm.handleBatchDropdownCommand },
                      scopedSlots: _vm._u([
                        {
                          key: "dropdown",
                          fn: function () {
                            return [
                              _c(
                                "el-dropdown-menu",
                                { staticClass: "batch-action-dropdown-menu" },
                                [
                                  _vm.activeTabName === "invoice-list"
                                    ? _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: "create-invoice",
                                            disabled:
                                              _vm.batchActionLoading.issue ||
                                              _vm.batchActionLoading.delete ||
                                              _vm.batchActionLoading
                                                .sendTaxAuthority ||
                                              _vm.loadingData,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Tạo mới HĐ\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.activeTabName === "invoice-list" &&
                                  _vm.checkPermission([
                                    "electronic-invoice-create-issued",
                                  ]) &&
                                  _vm.getSinvoiceConfigField(
                                    "usbDigitalSignature",
                                    false
                                  ) === false
                                    ? _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: "issue",
                                            disabled:
                                              _vm.batchActionLoading.issue ||
                                              _vm.batchActionLoading.delete ||
                                              _vm.batchActionLoading
                                                .sendTaxAuthority ||
                                              _vm.loadingData,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Phát hành hóa đơn\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.activeTabName === "invoice-list"
                                    ? _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: "release-invoice-draft",
                                            disabled:
                                              _vm.batchActionLoading.issue ||
                                              _vm.batchActionLoading.delete ||
                                              _vm.batchActionLoading
                                                .sendTaxAuthority ||
                                              _vm.batchActionLoading
                                                .updatePaymentStatus ||
                                              _vm.loadingData,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Phát hành HĐ nháp\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.activeTabName === "invoice-list"
                                    ? _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: "update-invoice-draft",
                                            disabled:
                                              _vm.batchActionLoading.issue ||
                                              _vm.batchActionLoading.delete ||
                                              _vm.batchActionLoading
                                                .sendTaxAuthority ||
                                              _vm.batchActionLoading
                                                .updatePaymentStatus ||
                                              _vm.batchActionLoading
                                                .updateDraftStatus ||
                                              _vm.loadingData,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Cập nhật trạng thái HĐ nháp\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.activeTabName === "issued-list"
                                    ? _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: "update-issue",
                                            disabled:
                                              _vm.batchActionLoading.issue ||
                                              _vm.batchActionLoading.delete ||
                                              _vm.batchActionLoading
                                                .sendTaxAuthority ||
                                              _vm.batchActionLoading
                                                .updatePaymentStatus ||
                                              _vm.loadingData,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Đồng bộ trạng thái HĐ\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.activeTabName === "issued-list"
                                    ? _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: "update-payment-status",
                                            disabled:
                                              _vm.batchActionLoading.issue ||
                                              _vm.batchActionLoading.delete ||
                                              _vm.batchActionLoading
                                                .sendTaxAuthority ||
                                              _vm.batchActionLoading
                                                .updatePaymentStatus ||
                                              _vm.loadingData,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Cập nhật trạng thái thanh toán\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.activeTabName === "issued-list" &&
                                  _vm.checkPermission(["send-tax-authority"]) &&
                                  _vm.getUsbDigitalSignatureConfig() === false
                                    ? _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: "sendTaxAuthority",
                                            disabled:
                                              _vm.batchActionLoading.delete ||
                                              _vm.batchActionLoading.issue ||
                                              _vm.batchActionLoading
                                                .sendTaxAuthority ||
                                              _vm.batchActionLoading
                                                .updatePaymentStatus ||
                                              _vm.loadingData,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Gửi cơ quan thuế\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.activeTabName === "invoice-list"
                                    ? _c(
                                        "el-dropdown-item",
                                        {
                                          staticClass:
                                            "batch-action-delete-item",
                                          attrs: {
                                            command: "delete",
                                            disabled:
                                              _vm.batchActionLoading.delete ||
                                              _vm.batchActionLoading.issue ||
                                              _vm.batchActionLoading
                                                .sendTaxAuthority ||
                                              _vm.batchActionLoading
                                                .updatePaymentStatus ||
                                              _vm.loadingData,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Xóa hóa đơn\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            size: "medium",
                            loading:
                              _vm.batchActionLoading.issue ||
                              _vm.batchActionLoading.delete ||
                              _vm.batchActionLoading.sendTaxAuthority ||
                              _vm.batchActionLoading.updatePaymentStatus ||
                              _vm.batchActionLoading.updateDraftStatus,
                            disabled: _vm.loadingData,
                          },
                        },
                        [
                          _vm._v("\n            Tác vụ\n            "),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "DialogBase",
        {
          attrs: {
            visible: _vm.confirmIssueDialogVisible,
            title: "Xác nhận",
            width: "500px",
            "use-panel": false,
            "close-on-click-modal": true,
            "append-to-body": "",
            "cancel-text": "Hủy",
            "confirm-text": "Đồng ý",
            "confirm-type": "primary",
            "cancel-icon": "",
            "confirm-icon": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.confirmIssueDialogVisible = $event
            },
            confirm: _vm.handleConfirmIssueSelectedInvoices,
          },
        },
        [
          _c("div", [
            _vm._v(
              "Bạn có chắc chắn muốn phát hành " +
                _vm._s(_vm.pendingIssueTransactionUuids.length) +
                " hóa đơn đã chọn không?"
            ),
          ]),
        ]
      ),
      _c(
        "DialogBase",
        {
          attrs: {
            visible: _vm.draftStatusDialogVisible,
            title: "Cập nhật trạng thái HĐ nháp",
            size: "sm",
            width: "520px",
            "panel-title": "Chọn thời gian đồng bộ",
            "panel-subtitle":
              "Bạn có thể đồng bộ theo tháng hoặc chọn tất cả thời gian",
            "panel-icon": "el-icon-date",
            "panel-icon-tone": "warning",
            "cancel-text": "Hủy",
            "confirm-text": "Đồng ý",
            "confirm-loading": _vm.batchActionLoading.updateDraftStatus,
            "confirm-disabled": _vm.isDraftStatusConfirmDisabled,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.draftStatusDialogVisible = $event
            },
            confirm: _vm.handleConfirmUpdateInvoiceDraftStatus,
          },
        },
        [
          _c(
            "div",
            { staticClass: "draft-status-time-form" },
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.draftStatusAllTime,
                    callback: function ($$v) {
                      _vm.draftStatusAllTime = $$v
                    },
                    expression: "draftStatusAllTime",
                  },
                },
                [_vm._v("Tất cả thời gian")]
              ),
              _c("el-date-picker", {
                staticClass: "draft-status-time-picker",
                attrs: {
                  type: "month",
                  "value-format": "M-yyyy",
                  format: "MM-yyyy",
                  placeholder: "Chọn tháng",
                  clearable: false,
                  disabled: _vm.draftStatusAllTime,
                },
                model: {
                  value: _vm.draftStatusMonth,
                  callback: function ($$v) {
                    _vm.draftStatusMonth = $$v
                  },
                  expression: "draftStatusMonth",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "DialogBase",
        {
          attrs: {
            visible: _vm.paymentStatusDialogVisible,
            title: "Cập nhật trạng thái thanh toán",
            width: "460px",
            "use-panel": false,
            "close-on-click-modal": true,
            "append-to-body": "",
            "cancel-text": "Hủy",
            "confirm-text": "Đồng ý",
            "confirm-type": "primary",
            "cancel-icon": "",
            "confirm-icon": "",
            "confirm-loading": _vm.batchActionLoading.updatePaymentStatus,
            "confirm-disabled": _vm.paymentStatusSelection === null,
          },
          on: {
            "update:visible": function ($event) {
              _vm.paymentStatusDialogVisible = $event
            },
            confirm: _vm.handleSelectPaymentStatus,
          },
        },
        [
          _c(
            "el-radio-group",
            {
              staticStyle: {
                "margin-top": "12px",
                display: "flex",
                gap: "18px",
              },
              model: {
                value: _vm.paymentStatusSelection,
                callback: function ($$v) {
                  _vm.paymentStatusSelection = $$v
                },
                expression: "paymentStatusSelection",
              },
            },
            [
              _c("el-radio", { attrs: { label: true } }, [
                _vm._v("Đã thanh toán"),
              ]),
              _c("el-radio", { attrs: { label: false } }, [
                _vm._v("Chưa thanh toán"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("InvoiceCreateDialog", {
        attrs: {
          isCreateInvoice: _vm.isCreateInvoice,
          invoicePurpose: _vm.invoicePurpose,
          isOpenInvoiceCreateDialog: _vm.invoiceCreateDialogVisible,
          initialItems: _vm.editingInvoiceItems,
          initialDraft: _vm.editingInvoiceDraft,
          editingTransactionUuid: _vm.editingTransactionUuid,
          kidCode: _vm.editingKidCode,
          orderKidCode: _vm.editingOrderKidCode,
        },
        on: {
          "update:isOpenInvoiceCreateDialog": function ($event) {
            _vm.invoiceCreateDialogVisible = $event
          },
          "update:is-open-invoice-create-dialog": function ($event) {
            _vm.invoiceCreateDialogVisible = $event
          },
          "invoice-action-success": _vm.handleInvoiceActionSuccess,
          "dialog-close": _vm.handleCloseInvoiceCreateDialog,
          back: _vm.handleCloseInvoiceCreateDialog,
          "clear-invoice-form": _vm.handleInvoiceFormCleared,
        },
      }),
      _c("InvoiceSendAppDialog", {
        attrs: {
          isOpenInvoiceSendAppDialog: _vm.isOpenInvoiceSendAppDialog,
          transactionUuid: _vm.transactionUuid,
        },
        on: { close: _vm.closeInvoiceSendAppDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }